

export type Language = {
    code: string;
    label: string;
    locale: string;
    flag: string;
    enabled: boolean;
  };
  
  export const LANGUAGES: Language[] = [
    {
      code: "fr",
      label: "Français",
      locale: "fr-FR",
      flag: "🇫🇷",
      enabled: true,
    },
    {
      code: "en",
      label: "English",
      locale: "en-US",
      flag: "🇬🇧",
      enabled: true,
    },
    {
      code: "de",
      label: "Deutsch",
      locale: "de-DE",
      flag: "🇩🇪",
      enabled: true,
    },
    {
      code: "es",
      label: "Español",
      locale: "es-ES",
      flag: "🇪🇸",
      enabled: true,
    },
    {
      code: "it",
      label: "Italiano",
      locale: "it-IT",
      flag: "🇮🇹",
      enabled: false,
    },
    {
      code: "zh-CN",
      label: "简体中文",
      locale: "zh-CN",
      flag: "🇨🇳",
      enabled: false,
    },
  ];


  export const DEFAULT_LANGUAGE = LANGUAGES.find(lang=>lang.code=='fr')